module.exports = __webpack_public_path__ + "static/media/jam-hortela.57fa51d3.png";